import cognitoAuth from '@/plugins/cognito'
import 'isomorphic-fetch'

let gql_endpoint = process.env.GQL_ENDPOINT
let read_gql_endpoint = process.env.READGQL_ENDPOINT

const deleteChapterQuery = `
  mutation($id: String!){
    deleteChapter(chapter:{
      id: $id
    }){
      id
      article_id
      posted_at
    }
  }`

const updateChapterQuery = `
mutation ($id: String!, $title: String!, $description: String!,$published: Boolean!, $article_id: String!, $posted_at: Float!, $logo_url: String, $time_to_complete: String!, $thumbnail_url: String, $captions_url: String, $chapters_url: String, $browser_title: String, $video_url: String, $header_background_color: String, $more_tutorials_link: String, $chapter_author_id: String, $video_duration: Float){
  updateChapter(chapter: {
    id: $id,
    title: $title,
    description: $description,
    published: $published,
    article_id: $article_id,
    posted_at: $posted_at,
    logo_url: $logo_url,
    time_to_complete: $time_to_complete,
    thumbnail_url: $thumbnail_url,
    captions_url: $captions_url,
    chapters_url: $chapters_url,
    browser_title: $browser_title,
    video_url: $video_url,
    header_background_color: $header_background_color,
    more_tutorials_link: $more_tutorials_link,
    chapter_author_id: $chapter_author_id,
    video_duration: $video_duration
  }) {
    id
    title
    description
    published
    article_id
    posted_at
    logo_url
    time_to_complete
    thumbnail_url
    captions_url
    chapters_url
    browser_title
    video_url
    header_background_color
    more_tutorials_link
    chapter_author_id
    video_duration
  }
}`

function authedQuery (query, variables, cb) {
  cognitoAuth.getIdToken(function (err, jwttoken) {
    if (err) {
      return cb(err)
    }
    var headers = new Headers({
      'Accept': 'application/json',
      'Authorization': jwttoken
    })

    fetch(gql_endpoint, {
      method: 'post',
      mode: 'cors',
      body: JSON.stringify({ query: query, variables: variables }),
      headers: {
        'Accept': 'application/json',
        'Authorization': jwttoken
      }
    }).then(response => {
      if (response.status === 200) {
        response.json().then((r) => {
          return cb(null, r)
        })
      }
    }).catch(err => {
      console.log('got err: ', err)
      return cb(err)
    })
  })
}

export default class gqlQuery {
  getTutorial (id, language, cb) {
    var headers = new Headers({
      'Accept': 'application/json'
    })
    // added posted_at and article_id, maybe needs to be read/write?
    const query = `query Single($id:String!,$language:String!){chapter(id:$id, language:$language){id
      title
      description
      published
      time_to_complete
      video_duration
      video_url
      captions_url
      raw_url
      chapters_url
      logo_url
      thumbnail_url
      more_tutorials_link
      chapter_author_id
      browser_title
      posted_at
      article_id
      header_background_color
      draft
      video_upload
      organization {id
      name
      allow_longform_video}
      steps{id
      title
      description
      start_time
      end_time}}}`

    var variables = {
      'id': id,
      'language': language
    }


    fetch(read_gql_endpoint, {
      method: 'post',
      mode: 'cors',
      body: JSON.stringify({ query: query, variables: variables }),
      headers: {
        'Accept': 'application/json'
      }

    }).then(response => {
      if (response.status === 200) {
        return cb(null, response)
      }
    }).then().catch(err => {
      return cb(err)
    })
  }

  newStep (variables, cb) {
    var query = `
    mutation ($title: String!, $description: String!,$chapter_id: String!, $start_time: String!, $end_time: String!) {
      createStep(step: {
        title: $title,
        description: $description,
        chapter_id: $chapter_id,
        start_time: $start_time,
        end_time: $end_time
      }) {
        id
        title
        description
        chapter_id
        start_time
        end_time
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateTutorial (variables, cb) {
    var query = `
    mutation ($id: String!, $title: String!, $description: String!, $published: Boolean!, $article_id: String!, $posted_at: Float!, $logo_url: String, $time_to_complete: String!, $thumbnail_url: String, $captions_url: String, $chapters_url: String, $browser_title: String, $video_url: String, $header_background_color: String, $more_tutorials_link: String, $chapter_author_id: String, $draft: String, $video_duration: Float){
      updateChapter(chapter: {
        id: $id,
        title: $title,
        description: $description,
        published: $published,
        article_id: $article_id,
        posted_at: $posted_at,
        logo_url: $logo_url,
        time_to_complete: $time_to_complete,
        thumbnail_url: $thumbnail_url,
        captions_url: $captions_url,
        chapters_url: $chapters_url,
        browser_title: $browser_title,
        video_url: $video_url,
        header_background_color: $header_background_color,
        more_tutorials_link: $more_tutorials_link,
        chapter_author_id: $chapter_author_id,
        draft: $draft,
        video_duration: $video_duration
      }) {
        id
        title
        description
        published
        article_id
        posted_at
        logo_url
        time_to_complete
        thumbnail_url
        captions_url
        chapters_url
        browser_title
        video_url
        header_background_color
        more_tutorials_link
        chapter_author_id
        draft
        video_duration
      }
    }`
    authedQuery(query, variables, cb)
  }

  publishDraft (variables, cb) {
    variables.published = true
    var query = `
    mutation ($id: String!, $title: String!, $description: String!, $published: Boolean!, $article_id: String!, $posted_at: Float!, $logo_url: String, $time_to_complete: String!, $thumbnail_url: String, $captions_url: String, $chapters_url: String, $browser_title: String, $video_url: String, $header_background_color: String, $more_tutorials_link: String, $chapter_author_id: String, $draft: String, $video_duration: Float){
      publishChapterDraft(chapter: {
        id: $id,
        title: $title,
        description: $description,
        published: $published,
        article_id: $article_id,
        posted_at: $posted_at,
        logo_url: $logo_url,
        time_to_complete: $time_to_complete,
        thumbnail_url: $thumbnail_url,
        captions_url: $captions_url,
        chapters_url: $chapters_url,
        browser_title: $browser_title,
        video_url: $video_url,
        header_background_color: $header_background_color,
        more_tutorials_link: $more_tutorials_link,
        chapter_author_id: $chapter_author_id,
        draft: $draft,
        video_duration: $video_duration

      }) {
        id
        title
        description
        published
        article_id
        posted_at
        logo_url
        time_to_complete
        thumbnail_url
        captions_url
        chapters_url
        browser_title
        video_url
        header_background_color
        more_tutorials_link
        chapter_author_id
        draft
        video_duration
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateStep (variables, cb) {
    var query = `
    mutation ($id: String!, $title: String!, $description: String!,$start_time: String!,$end_time: String!, $chapter_id: String!){
      updateStep(step: {
        id: $id,
        title: $title,
        description: $description,
        start_time: $start_time,
        end_time: $end_time,
        chapter_id: $chapter_id
      }) {
        id
        title
        description
        start_time
        end_time
        chapter_id
      }
    }`
    authedQuery(query, variables, cb)
  }

  deleteStep (variables, cb) {
    var query = `
      mutation($id: String!, $chapter_id: String!){
        deleteStep(step:{
          id: $id,
          chapter_id: $chapter_id
        }){
          id
          chapter_id
        }
      }`
    authedQuery(query, variables, cb)
  }

  newTutorial (variables, cb) {
    var query = `
    mutation ($title: String!, $description: String!,$article_id: String!, $logo_url: String, $time_to_complete: String!, $thumbnail_url: String, $captions_url: String, $chapters_url: String, $browser_title: String, $video_url: String, $header_background_color: String, $more_tutorials_link: String) {
      createChapter(chapter: {
        title: $title,
        description: $description,
        article_id: $article_id,
        logo_url: $logo_url,
        time_to_complete: $time_to_complete,
        thumbnail_url: $thumbnail_url,
        captions_url: $captions_url,
        chapters_url: $chapters_url,
        browser_title: $browser_title,
        video_url: $video_url,
        header_background_color: $header_background_color,
        more_tutorials_link: $more_tutorials_link
      }) {
        id
        title
        description
        article_id
        posted_at
        logo_url
        time_to_complete
        thumbnail_url
        captions_url
        chapters_url
        browser_title
        video_url
        header_background_color
        more_tutorials_link
        chapter_author_id
      }
    }`
    authedQuery(query, variables, cb)
  }

  updateChapterPublishStatus (variables, cb) {
    var query = `
    mutation ($id: String!,$published: Boolean!, $article_id: String!, $posted_at: Float!){
      updateChapterPublishStatus(chapter: {
        id: $id,
        published: $published
        article_id: $article_id,
        posted_at: $posted_at
      }) {
        id
        title
        article_id
        posted_at
        published
      }
    }`
    authedQuery(query, variables, cb)
  }

  deleteTutorial (id, cb) {
    var query = `mutation($id: String!){
      deleteChapter(chapter:{
        id: $id
      }){
        id
        article_id
        posted_at
      }
    }`

    var variables = {
      'id': id
    }
    authedQuery(query, variables, cb)
  }

  inviteUsers (users, organization_id, cb) {
    var user_string = JSON.stringify(users)
    user_string = user_string.replace(/\"([^(\")"]+)\":/g, '$1:') // This will remove all the quotes
    var query = `mutation{
      addUsersToOrganization(users: {
        users: ${user_string},
        organization_id:"${organization_id}"
      }){
        user_id
      }
    }`
    var variables = {
    }
    authedQuery(query, variables, cb)
  }

  updateOrgAccountDetails (params, cb) {
    var id = params.id || null
    var plan = params.plan || 'trial'
    var status = params.status || 'active'
    var trial_start_date = params.trial_start_date || new Date()
    //console.log("updateOrgAccountDetails: ", trial_start_date)

    var customer_id = params.customer_id || null
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var query = `
      mutation  {
        updateOrganization(organization: {
          id: "${id}",
          plan:"${plan}"
          customer_id:"${customer_id}"
          plan_status:"${status}",
          trial_start_date:"${trial_start_date}",
        }) {
          id

        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: headers

      }).then(response => {
        if (response.status === 200) {
          // todo refactor so .json() happens elsewhere and can be written with auth
          return cb(null, response.json())
        }

        throw `Bad status code ${response.status}`
      }).catch(err => {
        //console.log('error updating organization: ', err)
        return cb(err)
      })
    })
  }

  createOrganization (name, cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })
      
      var query = `
      mutation ($name: String!){
        createOrganization(organization: {
          name: $name
        }) {
          author_fullname
          author_id
          id
          name
          posted_at
        }
      }
      `
      var variables = `
      {
        "name":  ${name}
      }
      `

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }
      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
        throw `Bad status code ${response.status}`
      }).catch(err => {
        return cb(err)
      })
    })
  }
  getSpecificOrganization(id, cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var query = `
      query{
        organization (id:"${id}") {
          name
          plan
          plan_status
        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }
  getOrganization (cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var query = `
      query{
        organizations {
          id
          name
          plan
          plan_status
          trial_start_date
          customer_id
        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }

  deleteUserPermissions (user_id, cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var permission = {
        user_id: user_id
      }
      var query = `
      mutation {
        deleteUserPermission(permission: {
         user_id:"${user_id}"
       }) {
        user_id

      }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }

  getUserPermissions (organization_id, cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var query = `
      query{
        permissions (organization_id:"${organization_id}") {
          user_id
          organization_id
          admin
          cognito_sub
          name
        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }

  getArticles (cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })
      //console.log(jwttoken)
      var query = `
      query{
        articles {
          id
          organization_id
          organization_name
          title
          chapters {
            id
            chapter_author_id
            chapter_author_fullname
            title
            published

          }
        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }

  getAnalyticsLookup (cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })

      var query = `
      query{
        articles {
          id
          organization_id
          organization_name
          title
          chapters {
            id
            chapter_author_id
            chapter_author_fullname
            title
            steps {
              id
              title
              start_time
              start_time
            }
          }
        }
      }
      `
      var variables = ''

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }
  getChapterById (id, cb) {
    cognitoAuth.getIdToken(function (err, jwttoken) {
      if (err) {
        return cb(err)
      }
      var headers = new Headers({
        'Accept': 'application/json',
        'Authorization': jwttoken
      })
      

      var query = `
        query Single ($id: String!) {
          chapter (id: $id) {
            id
            article_id
            title
            description
            published
            video_url
            captions_url
            chapters_url
            browser_title
            time_to_complete
            video_url
            thumbnail_url
            logo_url
            posted_at
            more_tutorials_link
            header_background_color
            chapter_author_id
            steps {
              id
              title
              description
              start_time
              end_time
            }
            organization{
              name
              cdn_namespace
            }
          }
        }`
      var variables = {
        id: id
      }

      fetch(gql_endpoint, {
        method: 'post',
        mode: 'cors',
        body: JSON.stringify({ query: query, variables: variables }),
        headers: {
          'Accept': 'application/json',
          'Authorization': jwttoken
        }

      }).then(response => {
        if (response.status === 200) {
          return cb(null, response.json())
        }
      }).catch(err => {
        return cb(err)
      })
    })
  }

  onChange () { }
}

gqlQuery.install = function (Vue, options) {
  Object.defineProperty(Vue.prototype, '$gqlQuery', {
    get () { return this.$root._gqlQuery }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/gql/gql.js